var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContentDiv',{staticClass:"pa-0"},[_c('MapNodes')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }